import { Mediator, app } from "modular-openscriptjs";
import { eParse, inform } from "../helpers";
import { analyze } from "../analytics";
import { STRINGS, api, gc, uc } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class Setting extends Mediator {
	$$setting = {
		needs: {
			update: (ed, event) => {
				this.updateSettings(ed, event);
			},

			information: (ed, event) => {
				this.getSettings();
			},
		},
	};

	$$user = {
		authenticated_loggedOut: (ed, event) => this.getSettings(),
	};

	async updateSettings(ed, event) {
		let data = eParse(ed);

		let res = await api.put(`${routes.settings}/set/${data.message.path}`);

		if (!res) {
			return;
		}

		inform("Updated settings", STRINGS.SUCCESS);

		analyze("change_setting", {
			setting: data.message.path.split("/")[0],
			value: data.message.path.split("/")[1],
		});

		this.setSettings(res.data.settings);
		this.send($e.setting.updated, ed);
	}

	async getSettings() {
		if (!gc.auth.value) return;

		let res = await api.get(`${routes.settings}`, {}, { silent: true });

		if (!res) return;

		this.setSettings(res.data.settings);

		this.send($e.setting.has.information);
	}

	setSettings(settings = {}) {
		uc.settings.value = settings;
	}
}
